import { ApiService } from '@/api';
import { ActionIds, Guide, GuideStep } from '@/models/guides';

export class GuidesApi {
  private readonly baseUrl = '/api/guides';

  public async fetchAllGuides(): Promise<Guide[]> {
    const response = await ApiService.get(`${this.baseUrl}/pending`);

    return response.json();
  }

  public async fetchGuideSteps(guideId: string): Promise<GuideStep[]> {
    const response = await ApiService.get(`${this.baseUrl}/${guideId}/steps/pending`);

    return response.json();
  }

  public async markStepAsFinished(actionIds: ActionIds): Promise<void> {
    const GuideStepId = actionIds.stepId;
    await ApiService.post(
      `${this.baseUrl}/${actionIds.guideId}/steps`,
      { GuideStepId },
    );
  }
}
